export default defineNuxtRouteMiddleware(to => {
  if (to.path.startsWith('/article')) {
    // 取得路徑中的 slug 部分
    const slug = to.path.replace('/article', '')
    // 重定向到 hecen 路徑
    return navigateTo(`/hence`)
  }
})
